import { render, staticRenderFns } from "./TheModeC.vue?vue&type=template&id=10d06350&scoped=true&"
import script from "./TheModeC.vue?vue&type=script&lang=js&"
export * from "./TheModeC.vue?vue&type=script&lang=js&"
import style0 from "./TheModeC.vue?vue&type=style&index=0&id=10d06350&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d06350",
  null
  
)

component.options.__file = "TheModeC.vue"
export default component.exports